import { Icon, UptownLink } from "..";
import Styles from "./PostCard.module.css";

const PostCard = ({ post, variant }) => {
	if (post.url)
		return (
			<UptownLink
				link={{ link_type: "Document", url: post?.url }}
				className={Styles.cardWrapper}
			>
				<div
					className={Styles.card}
					style={{
						backgroundImage: post?.data?.featured_image?.url
							? `url(${post.data.featured_image.url})`
							: undefined,
					}}
					data-variant={variant}
				>
					<h4 className={Styles.title}>{post?.data?.title}</h4>
					<div className={Styles.btn}>
						{variant == "Video" ? "Watch Now" : "Read Now"}
						{variant !== "Video" && variant !== "Large" && (
							<Icon icon="ChevronRight" size={24} />
						)}
					</div>
					{variant == "Video" && (
						<div className={Styles.iconWrapper}>
							<Icon icon="Play" size={16} className={Styles.icon} />
						</div>
					)}
				</div>
			</UptownLink>
		);
};

export default PostCard;
